import moment from "moment";

const BusinessAdministrationValidator = (t) => {
  moment.locale("es");
  let regexs = {
    rfcRegex: new RegExp(
      /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A-Z\d])$/
    ),
    businessNameRegex: new RegExp(
      /^(?=.*\S)[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/
    ),
    nameSocialRegex: new RegExp(
      /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9&.,()\-\/#' ]+$/
    ),
    businessDescription: new RegExp(
      /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/
    ),
    moralRfcRegex: new RegExp(/^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    nameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    firstLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    secondLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    emailRegex: new RegExp(/^[a-zA-ZñÑ0-9._-]+@([a-zA-Z0-9._-]+\.)+[\w-]{2,}$/),
  };

  let validators = {
    rfcValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.rfcRegex.test(value.toUpperCase())
            ? ""
            : t("businessAdministrationValidator.rfcValidator");
        }
      }
    },
    businessNameValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.businessNameRegex.test(value)
            ? ""
            : t("businessAdministrationDetailView.errorBusinessName");
        }
      }
    },
    emailValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.emailRegex.test(value)
            ? ""
            : t("signature.request.emailValidator");
        }
      }
    },
    nameSocialValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.nameSocialRegex.test(value.trim())
            ? ""
            : t("businessAdministrationDetailView.errorNameSocial");
        }
      }
    },
    businessDescriptionValidator: (value) => {
      if (value !== null && value !== undefined && value.length > 0) {
        return regexs.businessDescription.test(value)
          ? ""
          : t("businessAdministrationDetailView.errorBusinessName");
      } else {
        return ""; // acepta vacío
      }
    },
    nameValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return (regexs.nameRegex.test(value) ? '' : t("profile.validator.nameValidator"))
        }
      }
    },
    firstLastNameValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return (regexs.firstLastNameRegex.test(value) ? '' : t("profile.validator.firstLastNameValidator"))
        }
      }
    },
    secondLastNameValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return (regexs.secondLastNameRegex.test(value) ? '' : t("profile.validator.secondLastNameValidator"))
        }
      }
    },
    moralRFCValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.moralRfcRegex.test(value.toUpperCase())
            ? ""
            : t("businessAdministrationValidator.rfcValidator");
        }
      }
    }
  };
  return validators;
};

export default BusinessAdministrationValidator;
